import { signOut, useSession } from 'next-auth/react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/form';
import Logo from 'components/Logo';

import { PAGE_ROUTES } from 'lib/page-routes';
import { useAuth } from 'lib/providers/AuthProvider';

import { StepHeading } from '../../Steps';
import styles from './SuccessScreen.module.scss';

export const SuccessScreen: React.FC = () => {
  const { status } = useSession();

  const [t] = useTranslation('signup.manager.success');

  const { managerSociety, onUserLogout } = useAuth();

  useEffect(() => {
    window.addEventListener('beforeunload', () => {
      onUserLogout();
    });
  }, []);

  useEffect(() => {
    if (status === 'authenticated') {
      signOut({ redirect: false });
    }
  }, [status]);

  return (
    <div className={styles.finalStep}>
      <Logo
        name="huzzle-new"
        size="small"
        color="black"
        className={styles.logo}
      />
      <div className={styles.content}>
        <img src={'/images/pre-approval-signup-final.png'} />
        <StepHeading title={t('header.title')} desc={t('header.desc')} />
        <Button
          className={styles.button}
          onClick={() => {
            if (status === 'authenticated') {
              signOut({ redirect: false });
            }
            const slug = managerSociety?.slug;
            const win = window.open(
              `${PAGE_ROUTES.SOCIETIES}/${slug}`,
              '_blank'
            );
            win?.focus();
          }}
          color="secondary"
          isFullWidth
          borderless
        >
          {t('button')}
        </Button>
      </div>
    </div>
  );
};
